import { CultureService, Language } from '@paypoint-frontend/web-core';

import { inject } from '@angular/core';
import { LangService } from '@core/services';

export function langInitializer(): Promise<unknown> {
  const langService = inject(LangService);
  const cultureService = inject(CultureService);

  return new Promise<void>((resolve) => {
    langService.getLangs().subscribe({
      next: (output: Language[]) => {
        cultureService.init(output);
        resolve();
      },
      error: () => {
        resolve();
      },
    });
  });
}
